import React from 'react';
import CaseStudyLayout from '../../../components/caseStudy/index';
import { hem } from '../image_index';
import { sections } from './config';

const HEM = () => {
    return (
        <CaseStudyLayout
            title='An Improved Health-E-Messaging'
            subtitle='Streamlining Academic Healthcare Workflows via UX Optimization'
            heroImage={[hem]}
            for='ECS 164 - Human-Computer Interaction (UCD)'
            duration='January 2022 - March 2022'
            tools='Figma, React'
            team='Devin Ly, Mindy Mohr, Eric Ni, Justin Rusit, Christina Vo, Cameron Yee'
            role='UI/UX Prototype Designer, UX Research'
            summary={(
                <p>
                    A comprehensive UX redesign and frontend prototype of UC Davis's Health-E-Messaging portal, focusing on optimizing mandatory COVID-19 testing scheduling by reducing workflow friction, cognitive load, and task completion times.
                </p>
            )}
            sections={sections}
        />
    );
}

export default HEM;